import login from './login';

export default {
  language: 'da-DK',
  country: 'dk',
  name: 'Dansk',
  embeddedLocale: login,
};
